<template>
  <div class="relative">
    <div class="relative">
      <label v-if="hasDefaultSlot" :for="inputId" class="mb-2 block font-bold"><slot /></label>
      <div class="relative">
        <input class="p-5 focus:outline-none w-full"
               :id="inputId"
               :class="[{'has-error pr-8' : (isValid === false)},inputClass]"
               :type="type === 'password' ? passType : type"
               :name="name"
               :autocomplete="autocomplete"
               :value="value"
               :autofocus="autofocus"
               :ref="name"
               :placeholder="placeholder"
               :aria-label="placeholder"
               @input="inputEvent"
               @focus="$emit('focus')"
               @blur="$emit('blur')"
               @keyup.enter="keyupEnter"
               @keyup="keyup"
               :readonly="readonly"
               :required="required"
        >
        <svg class="icon" height="16" width="16" v-if="isValid === false && hasValidator === true">
          <line x1="0" y1="0" x2="16" y2="16" style="stroke:#d9001a; stroke-width: 1px" />
          <line x1="0" y1="16" x2="16" y2="0" style="stroke:#d9001a; stroke-width: 1px" />
        </svg>
      </div>
    </div>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'
import Validation from '../mixins/Validation.js'

export default {
  name: 'BaseInput',
  mixins: [Validation],
  components: {
    ValidationMessages
  },
  data () {
    return {
      passType: 'password',
      iconActive: false,
      icon: 'visibility',
      isDirty: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  props: {
    inputId: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    inputClass: {
      type: String,
      required: false,
      default: ''
    },
    validation: {
      type: Object,
      required: false,
      default: () => { }
    },
    validations: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    togglePassType () {
      if (this.passType === 'password') {
        this.passType = 'text'
        this.icon = 'visibility_off'
      } else {
        this.passType = 'password'
        this.icon = 'visibility'
      }
    },
    // setFocus sets focus on a field which has a value of 'ref' tag equal to fieldName
    setFocus (fieldName) {
      if (this.name === fieldName) {
        this.$refs[this.name].focus()
      }
    },
    keyup ($event) {
      this.$emit('keyup', $event)
      this.isDirty = true
    },
    keyupEnter ($event) {
      this.$emit('keyup.enter', $event.target.value)
      this.isDirty = true
    },
    inputEvent ($event) {
      this.$emit('input', $event.target.value)
      this.isDirty = true
    }
  },
  created () {
    if (this.type === 'password') {
      this.iconActive = true
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs[this.name].focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  input {
    @apply border;
  }
  .icon {
    position: absolute;
    right: 12px;
    top: 40%;
  }

  .icon-md {
    font-size: 21px;
    font-weight: 300;
    transform: scale(1.2, 1);
  }

  .has-error {
    @apply border-red;
  }
</style>
